import {
    uploadAnalysisFileAPI,
    getAnalysisFilesAdminAPI,
    deleteAnalysisFileAdminAPI,
} from "./api"

export function uploadAnalysisFile(formData) {
    return new Promise((resolve, reject) => {
        uploadAnalysisFileAPI(formData).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function getAnalysisFilesAdmin(store) {
    return new Promise((resolve, reject) => {
        getAnalysisFilesAdminAPI(store).then((res) => resolve(res)).catch(err => reject(err))
    })
}

export function deleteAnalysisFileAdmin(data) {
    return new Promise((resolve, reject) => {
        deleteAnalysisFileAdminAPI(data).then((res) => resolve(res)).catch(err => reject(err))
    })
}
